import React, { useState } from 'react';
import { ShoppingCartIcon, UserIcon, MenuIcon, XIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return <header className="sticky top-0 z-50 bg-white shadow-md" data-id="element-117">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-118">
        <div className="flex justify-between items-center h-20" data-id="element-119">
          {/* Logo */}
          <div className="flex-shrink-0" data-id="element-120">
            <div className="text-2xl font-bold text-blue-900" data-id="element-121">
              Mega Revolution
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" aria-label="Main navigation" data-id="element-122">
            <a href="#inicio" className="text-gray-700 hover:text-blue-900 font-medium transition-colors" data-id="element-123">
              Inicio
            </a>
            <a href="#tienda" className="text-gray-700 hover:text-blue-900 font-medium transition-colors" data-id="element-124">
              Tienda
            </a>
            <a href="#combos" className="text-red-600 hover:text-red-700 font-semibold transition-colors" data-id="element-125">
              Combos de comida en Cuba
            </a>
            <a href="#servicios" className="text-gray-700 hover:text-blue-900 font-medium transition-colors" data-id="element-126">
              Servicios
            </a>
            <a href="#envios" className="text-gray-700 hover:text-blue-900 font-medium transition-colors" data-id="element-127">
              Envíos
            </a>
            <a href="#contacto" className="text-gray-700 hover:text-blue-900 font-medium transition-colors" data-id="element-128">
              Contacto
            </a>
          </nav>

          {/* Right Side Icons & CTA */}
          <div className="flex items-center space-x-4" data-id="element-129">
            <button className="p-2 text-gray-700 hover:text-blue-900 transition-colors" aria-label="Shopping cart" data-id="element-130">
              <ShoppingCartIcon className="h-6 w-6" data-id="element-131" />
            </button>
            <button className="p-2 text-gray-700 hover:text-blue-900 transition-colors" aria-label="User account" data-id="element-132">
              <UserIcon className="h-6 w-6" data-id="element-133" />
            </button>
            <Button variant="primary" className="hidden md:block" data-id="element-134">
              Enviar ahora
            </Button>

            {/* Mobile menu button */}
            <button className="md:hidden p-2 text-gray-700" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-135">
              {mobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-136" /> : <MenuIcon className="h-6 w-6" data-id="element-137" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && <nav className="md:hidden py-4 border-t" aria-label="Mobile navigation" data-id="element-138">
            <div className="flex flex-col space-y-4" data-id="element-139">
              <a href="#inicio" className="text-gray-700 hover:text-blue-900 font-medium" data-id="element-140">
                Inicio
              </a>
              <a href="#tienda" className="text-gray-700 hover:text-blue-900 font-medium" data-id="element-141">
                Tienda
              </a>
              <a href="#combos" className="text-red-600 hover:text-red-700 font-semibold" data-id="element-142">
                Combos de comida en Cuba
              </a>
              <a href="#servicios" className="text-gray-700 hover:text-blue-900 font-medium" data-id="element-143">
                Servicios
              </a>
              <a href="#envios" className="text-gray-700 hover:text-blue-900 font-medium" data-id="element-144">
                Envíos
              </a>
              <a href="#contacto" className="text-gray-700 hover:text-blue-900 font-medium" data-id="element-145">
                Contacto
              </a>
              <Button variant="primary" className="w-full" data-id="element-146">
                Enviar ahora
              </Button>
            </div>
          </nav>}
      </div>
    </header>;
}